module.exports = __webpack_public_path__ + "static/media/rural.045d1dfd.png";